module.exports = require("discourse/lib/deprecated");